import React from "react"
import { Link, useNavigate, useLocation } from "react-router-dom"
import { useRecoilState, useRecoilValue } from "recoil"
import {
  sizeState,
  themeState,
  userObjState,
  pagesNprofileState,
  updatedPagesObjState,
  updatedProfileObjState,
  editModeState,
  editObjState,
  editedPagesState,
} from "../recoil-atom"

import { authService, dbService } from "../fbase"
import {
  collection,
  query,
  where,
  orderBy,
  limit,
  doc,
  setDoc,
  getDoc,
  addDoc,
  getDocs,
  onSnapshot,
  writeBatch,
} from "firebase/firestore"

import styled, { css } from "styled-components"
import { Button, Flex } from "../styled-components-openmark"

import { UserRectangle, CheckSquare } from "@styled-icons/boxicons-solid"
import { Login, Logout } from "@styled-icons/heroicons-outline"
import { Edit } from "@styled-icons/fluentui-system-filled"

const Nav = ({ refreshUser }) => {
  const [size, setSize] = useRecoilState(sizeState)
  const [theme, setTheme] = useRecoilState(themeState)
  const [userObj, setUserObj] = useRecoilState(userObjState)
  const { pagesObj, profileObj, shortName } = useRecoilValue(pagesNprofileState)
  const [updatedPagesObj, setUpdatedPagesObj] =
    useRecoilState(updatedPagesObjState)
  const [editMode, setEditMode] = useRecoilState(editModeState)
  const [editedPages, setEditedPages] = useRecoilState(editedPagesState)

  const navigate = useNavigate()
  const location = useLocation()

  const saveUserObj = async () => {
    if (editMode === true) {
      if (JSON.stringify(updatedPagesObj) !== JSON.stringify(pagesObj)) {
        const now = new Date().getTime()
        const newUserObj = {
          ...userObj,
          pageOrder: updatedPagesObj.pageOrder,
          page0: updatedPagesObj.page0,
          page1: updatedPagesObj.page1,
          page2: updatedPagesObj.page2,
          page3: updatedPagesObj.page3,
          updatedAt: now,
        }
        setUserObj(newUserObj)
        window.localStorage.setItem("user", JSON.stringify(newUserObj))

        // Get a new write batch
        const batch = writeBatch(dbService)

        // Update the population of editedPages
        const userRef = doc(dbService, "users", userObj.uid)
        batch.update(userRef, newUserObj)

        // Commit the batch
        await batch.commit()

        setEditedPages([])
      }
      setEditMode(false)
    } else {
      setEditMode(true)
    }
  }

  return (
    <>
      <div className="navigation" width={size.appWidth}>
        <Link to="/" alt="home">
          <Flex>
            {/* <Grid size="20" /> */}
            <img src="/logoB-32x32.png" width="20px" />
            openmark
          </Flex>
        </Link>

        {location.pathname === "/" && (
          <Flex center button onClick={saveUserObj}>
            {editMode ? (
              <>
                <CheckSquare size="20" color="#800F00" />
                <span style={{ color: "#800F00" }}>저장</span>
              </>
            ) : (
              <>
                <Edit size="20" /> 편집
              </>
            )}
          </Flex>
        )}
        {location.pathname === "/profile" && <Flex center>프로필</Flex>}
        {location.pathname === "/usage" && <Flex center>사용안내</Flex>}
        {location.pathname === "/about" && <Flex center>Jace소개</Flex>}
        {location.pathname === "/finance" && <Flex center>금융,주식</Flex>}
        {["/", "/profile", "/finance", "/usage", "/about"].includes(location.pathname) || (
          <Flex center>Not Found</Flex>
        )}

        <Flex right>
          {userObj ? (
            <>
              <Link to="/profile">
                <Flex>
                  <UserRectangle size="20" color="#777" />
                  &nbsp;
                  {shortName}
                  &nbsp;
                </Flex>
              </Link>

              <Link>
                <Flex>
                  <Logout
                    size="20"
                    onClick={async () => {
                      await authService.signOut()
                      setUserObj(null)
                      window.localStorage.setItem("user", null)
                      navigate("/auth")
                      window.location.reload()
                    }}
                  />
                </Flex>
              </Link>
            </>
          ) : (
            <>
              <Link to="/auth">
                <Flex>
                  Sign In&nbsp;
                  <Login size="20" />
                </Flex>
              </Link>
            </>
          )}
        </Flex>
      </div>

      <style jsx>{`
        .navigation {
          position: sticky;
          z-index: 10;
          top: 0;
          margin: 0 auto;
          padding: 10px;
          width: ${size.appWidth}px;
          border-radius: 0 0 10px 10px;
          background-color: ${userObj ? userObj.colors.b1 : theme.b1};
          box-shadow: 1px 1px 3px 1px ${userObj ? userObj.colors.b2 : theme.b2};
          color: ${userObj ? userObj.colors.f2 : theme.f2};
          display: grid;
          grid-template-columns: 1fr 1fr 1fr;
          justify-content: center;
          align-items: center;
          /* justify-content: space-between; */
        }
      `}</style>
    </>
  )
}

export default Nav
